import React, {memo} from 'react'
import {Box, ListItem as ListItemUI, ListItemIcon, ListItemText, Tooltip} from '@material-ui/core';
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/styles';
import clsx from 'clsx';
// import { redirect } from 'libs/RouterPath';
import {withRouter} from "react-router";
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const style = theme => ({
	leftMargin: {
		marginLeft: theme.spacing(3)
	},
	rightIcon: {
		minWidth: 'unset'
	},
	iconOpen: {
		transform: 'rotate(-180deg)',
	},
	contrastColor: {
		color: theme.palette.primary.contrastText,
	},
	elementColor: {
		...theme.components.navigation.item.primary
	},
	mainPadding: {
		paddingLeft: 0,
	},
	iconInnerOpen: {
		transform: 'rotate(90deg)',
	},
	innerArrow: {
		minWidth: theme.spacing(3)
	},
	text: {
		whiteSpace: "normal"
	},
	iconContrast: {
		fill: theme.palette.primary.main,
	},
	onHover: {
		'&:hover': {
			background: theme.palette.primary.light,
			color: theme.palette.secondary.contrastText,
			'& $iconContrast': {
				fill: theme.palette.secondary.contrastText,
			}
		}
	},
	epmptySpace: {
		width: theme.spacing(3)
	},
	textBox: {
		maxWidth: 200
	}
})

function ListItem({
	Icon = "",
	onClick,
	className,
	classes,
	classesObj,
	iconPosition,
	open,
	// href,
	location,
	setInnerMenuOpen,
	innerMenu,
	// innerKey,
	// directLink,
	openInner,
	name,
	url,
	innerKey,
	singleLink,
	setMenuOpen,
	tooltip
}) {
	const renderItem = (component, shouldRender) => {
		// return Icon && (shouldRender ? component : '')
		return (shouldRender ? component : '')
	}

	const isSelected = (() => {
		if (!url) return false;
		const path = location.pathname;

		return (path.startsWith(url) && url.length > 1) || path === url;
	})();

	const iconBase = (className = '') => (
		<ListItemIcon className={className} >
			<Icon
				className={clsx({
					[classes.iconOpen]: open,
					[classes.contrastColor]: isSelected,
					[classes.iconContrast]: !isSelected
				}, classesObj.icon
				)}
			/>
		</ListItemIcon>
	)

	const icon = (tooltip, className) => {
		if (!tooltip) {
			return iconBase(className);
		}
		return (
			<Tooltip
				title={tooltip}
			>
				{iconBase(className)}
			</Tooltip>
		)
	}


	const onArrowClick = () => {
		if (setInnerMenuOpen) {
			if (iconPosition === "right") {
				for (const x in innerMenu) innerMenu[x] = false
				setInnerMenuOpen({ ...innerMenu })
			} else {
				setInnerMenuOpen({
					...innerMenu,
					[innerKey]: !innerMenu[innerKey]
				})
			}
			setMenuOpen(true);
		}
	}


	const handleClick = () => {
		onClick();
		// if (href) { redirect(href) }
		if (url) window.location.href = url

		if (singleLink) window.location.href = singleLink
		else onArrowClick()
	}

	const itemClass = clsx(className, classes.onHover, {
		[classes.elementColor]: isSelected,
		[classes.mainPadding]: openInner
	})
	return (
		<ListItemUI
			button
			className={itemClass}
			onClick={handleClick}
		>
			{singleLink ?
				<Box component="div" className={classes.epmptySpace} />
				:
				openInner && (
					innerKey ?
						<ArrowRightIcon
							className={clsx({
								[classes.contrastColor]: isSelected,
								[classes.iconInnerOpen]: innerMenu[innerKey],
							}, classes.innerArrow)} />
						:
						<Box className={classes.leftMargin} />
				)
			}
			{Icon && renderItem(icon(name), iconPosition === 'left')}
			<ListItemText
				className={clsx({ [classes.textBox]: iconPosition === 'left' })}
				primary={name}
				primaryTypographyProps={{
					noWrap: true,
					className: clsx({
						[classes.contrastColor]: isSelected,
						[classes.text]: openInner,
					})
				}}
			/>
			{renderItem(icon(tooltip, classes.rightIcon), iconPosition === 'right')}
		</ListItemUI>
	)
}

ListItem.propTypes = {
	// text: PropTypes.string,
	// icon: PropTypes.object,
	onClick: PropTypes.func,
	className: PropTypes.string,
	classesObj: PropTypes.shape({
		icon: PropTypes.string,
	}),
	iconPosition: PropTypes.oneOf(['left', 'right']),
	// href: PropTypes.string,
}

ListItem.defaultProps = {
	// text: '',
	classesObj: {
		icon: '',
	},
	iconPosition: 'left',
	open: false,
	onClick: () => { },
}

export default withRouter(withStyles(style)(memo(ListItem, (prevProps, nextProps) => {
	if (prevProps.location.pathname !== nextProps.location.pathname) return false;
	if (prevProps.open !== nextProps.open) return false;
	if (prevProps.openInner !== nextProps.openInner) return false;
	if (prevProps.className !== nextProps.className) return false;
	if (JSON.stringify(prevProps.classes) !== JSON.stringify(nextProps.classes)) return false;
	if (JSON.stringify(prevProps.classesObj) !== JSON.stringify(nextProps.classesObj)) return false;
	if (JSON.stringify(prevProps.innerMenu) !== JSON.stringify(nextProps.innerMenu)) return false;
	return true;
})))
